module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "block_114",
    attrs: {
      "id": "id_Toc176537614"
    }
  }, [_vm._v("Chapter 4")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_vm._v("As the weather changed and the flat came under attack from much stronger curry batches, Steven had the idea of trying to find less pongy accommodation. As it happened, a UK service member of the departing course, normally accommodated near the College, was listing his accommodation on the College user guide. Steven spotted the ground floor flat in Kensington that, although slightly further from the College, offered better accommodation in a more respectful neighbourhood with upmarket credentials. The price was within budget but needed a proper shower and a new mattress.")]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_vm._v("The outgoing air commodore was happy to arrange the transfer and Abingdon Street in posh South Kensington was a refreshing change. Using the tube from South Kensington to Hyde Park corner was a gentle wake-up in the morning at four minutes max. The three-hundred-yard stroll to Belgrave Square was an uplifting feeling reminding him that he was at the centre of the world. The echoes of Victoria Bus Station at six in the morning would never leave him. Memories of hardship past were always welcome.")]), _vm._v(" "), _c('p', {
    staticClass: "block_8",
    attrs: {
      "id": "calibre_pb_9"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75f970fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_004.vue
// module id = 75
// module chunks = 0